import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取得意先分组列表 #10045 */
export function getErpGroupList(data) {
  return request("".concat(BASE_URL) + "/erp/customer/group/list", METHOD.GET, data);
}

/* 删除得意先分组 #10044 */
export function deleteErpByid(groupId) {
  return request("".concat(BASE_URL) + "/erp/customer/group/" + groupId, METHOD.DELETE);
}
/* 保存得意先分组（#10043） */
export function saveErp(data) {
  return request("".concat(BASE_URL) + "/erp/customer/group", METHOD.POST, data);
}

/* 获取得意先分组详情（#10046） */
export function getErpDetail(erpCustomerGroupId) {
  return request("".concat(BASE_URL) + "/erp/customer/group/detail/" + erpCustomerGroupId, METHOD.GET);
}
export default {
  getErpGroupList: getErpGroupList,
  deleteErpByid: deleteErpByid,
  saveErp: saveErp,
  getErpDetail: getErpDetail
};